<template>
  <div id="app" class="site">
    <main class="site-content">
      <header>
        <navbar></navbar>
      </header>
      <app-header v-if="showHeader"></app-header>
      <div class="container content-wrapper">
        <router-view></router-view>
      </div>
    </main>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'
import myMixin from 'mixins'

export default {
  components: {Navbar, AppHeader, AppFooter},
  mixins: [myMixin],
  name: 'app',
  computed: {
    showHeader: function () {
      let isVisible = true
      let hideOnPages = ['/list-beers', '/my-beers', '/facts']

      if (hideOnPages.indexOf(this.$route.path) !== -1) isVisible = false

      return isVisible
    }
  },
  mounted () {
    this.$store.dispatch('loadRatingList')
    this.$store.dispatch('loadData')

    if (this.getCookie('userName')) {
      // Set name to store
      this.$store.dispatch('setRaterName', this.getCookie('userName'))
    }
  }
}
</script>

<style lang="scss">
@import 'assets/styles/config.scss';

.site {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

.site-content {
  flex: 1;
}

.content a:not(.button):visited {
  color: #222;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.form-group {
  padding: 0 20px;
}
.spacer {
  padding-top: 28px;
}

</style>



// WEBPACK FOOTER //
// App.vue?60cbe8e8